module.exports = __webpack_public_path__ + "media/images/blazestake-logo-20137c57.png";